import React, { useMemo } from "react";
import { Box } from "@mui/material";
import JsonPreview from "../../../../components/common/JsonPreview";

/**
 * The submission record as it came off the API.
 *
 * Grid-internal keys (`__type` and the grouping fields this screen stamps on
 * each row) are stripped — they're presentation state, and leaving them in makes
 * the payload look like it carries fields the backend never sent.
 *
 * Syntax colouring is done by regex over the serialized text rather than by
 * walking the object: the output is already a string, the token shapes are
 * unambiguous in JSON, and it keeps this to one pass with no dependency.
 */
const INTERNAL_KEYS = /^__/;

const highlight = (json) =>
  json
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/"([^"]+)":/g, '<span class="jk">"$1"</span>:')
    .replace(/: "([^"]*)"/g, ': <span class="js">"$1"</span>')
    .replace(/: (-?\d+\.?\d*)/g, ': <span class="jn">$1</span>')
    .replace(/: (true|false)/g, ': <span class="jn">$1</span>')
    .replace(/: null/g, ': <span class="jnull">null</span>');

const SubmissionJsonTab = ({ row }) => {
  const html = useMemo(() => {
    if (!row) return "";
    const clean = Object.fromEntries(
      Object.entries(row).filter(([k]) => !INTERNAL_KEYS.test(k)),
    );
    return highlight(JSON.stringify(clean, null, 2));
  }, [row]);

  if (!row) return null;

  return (
    <Box
      sx={{
        // background: "#e8e9ec",
        // borderRadius: "10px",
        // p: "16px 18px",
        m: 0,
        fontFamily: '"SF Mono", ui-monospace, Menlo, Consolas, monospace',
        fontSize: 12,
        lineHeight: 1.7,
        color: "#C9D5E8",
        maxHeight: 1440,
        overflow: "auto",
        "& .jk": { color: "#7FB5F5" },
        "& .js": { color: "#8FD9A8" },
        "& .jn": { color: "#F0B86E" },
        "& .jnull": { color: "#8593A8", fontStyle: "italic" },
      }}
    >
      <JsonPreview values={row} lineHeight={1.2} fontSize={11} />
    </Box>
  );
  return (
    <Box
      component="pre"
      dangerouslySetInnerHTML={{ __html: html }}
      sx={{
        background: "#0B1526",
        borderRadius: "10px",
        p: "16px 18px",
        m: 0,
        fontFamily: '"SF Mono", ui-monospace, Menlo, Consolas, monospace',
        fontSize: 12,
        lineHeight: 1.7,
        color: "#C9D5E8",
        maxHeight: 440,
        overflow: "auto",
        "& .jk": { color: "#7FB5F5" },
        "& .js": { color: "#8FD9A8" },
        "& .jn": { color: "#F0B86E" },
        "& .jnull": { color: "#8593A8", fontStyle: "italic" },
      }}
    />
  );
};

export default SubmissionJsonTab;
